// Pick a stable, distinct color per activity type for UI chips (e.g. the
// ActivityFilterPanel). The live map preview intentionally does NOT use this
// — it renders every polyline with the single common color set in
// `settings.activities.color`, so the preview stays calm and the per-type
// settings only surface in the generated image.

const hashString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getActivityTypeColor = (type, activitySettings) => {
  const explicit = activitySettings?.byType?.[type]?.color;
  if (explicit) return explicit;
  if (!type) return activitySettings?.color || '#e11d48';
  const hue = hashString(type) % 360;
  return `hsl(${hue}, 80%, 60%)`;
};
